import i18n from '../../i18n';

const MissionData = [
    {
        id: 1,
        text: i18n.t('data2.mission1')
    },
    {
        id: 2,
        text: i18n.t('data2.mission2')
    },
    {
        id: 3,
        text: i18n.t('data2.mission3')
    },
    {
        id: 4,
        text: i18n.t('data2.mission4')
    },
    {
        id: 5,
        text: i18n.t('data2.mission5')
    }
]

export default MissionData;